(function () {
  'use strict';

  var INIT_FLAG = 'aeyaArticleInited';

  function init(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return;
    root.dataset[INIT_FLAG] = 'true';

    var announce = document.querySelector('.aeya-announcement');
    var announceSection = (announce && announce.closest('.shopify-section')) || announce;
    var headerBar = document.querySelector('.aeya-header__bar') || document.querySelector('.aeya-header');
    var headerEl = document.querySelector('.aeya-header');

    function readVar(el, name, fallback) {
      var v = parseFloat(getComputedStyle(el).getPropertyValue(name));
      return isNaN(v) ? fallback : v;
    }

    function applyOffset() {
      var a = announceSection ? Math.round(announceSection.getBoundingClientRect().height) : 0;
      var h = readVar(document.body, '--header-height', 0);
      if (!h && headerBar) h = Math.round(headerBar.getBoundingClientRect().height);
      root.style.setProperty('--aeya-article-offset', (a + h) + 'px');
    }

    function applyStickyTop() {
      var gap = readVar(root, '--aeya-article-gap', 20);
      var hb = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
      if (hb < 0) hb = 0;
      root.style.setProperty('--aeya-article-sticky-top', Math.round(hb + gap) + 'px');
    }

    function applyAll() { applyOffset(); applyStickyTop(); }

    var rafPending = false;
    function onScroll() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { applyAll(); rafPending = false; });
    }

    applyAll();
    requestAnimationFrame(applyAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyAll);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(applyAll);
      if (announceSection) ro.observe(announceSection);
      if (headerBar) ro.observe(headerBar);
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('orientationchange', onScroll);
  }

  function initAll() {
    document.querySelectorAll('.aeya-article-main[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.aeya-article-main[data-section-id]');
    if (root) init(root);
  });
})();
